<input
  #googleAutocompleteInput
  [value]="value"
  (input)="onInputChange($event)"
  (blur)="onInputBlur($event)"
  [class.error]="touched() && invalid()"
  [class.disabled]="disabled()"
  placeholder="Address"
  class="f-control"
/>
